export const plansListStyles = {
  tableContainer: {
    borderRadius: "12px",
    border: "1px solid var(--Gray-200, #E4E7EC)",
    background: "#FFF",
  },
  tablePlanItemCell: {
    padding: "32px 24px 24px",
    borderRight: "1px solid var(--Gray-200, #E4E7EC) !important",
    verticalAlign: "top",
    width: "100%",
    "&:last-child": {
      borderRight: "none !important",
    },
  },
  tablePlanActionItemCell: {
    padding: "24px",
    borderRight: "1px solid var(--Gray-200, #E4E7EC) !important",
    "&:last-child": {
      borderRight: "none !important",
    },
  },
  upgradeToPlanButton: {
    color: "var(--Base-White, #FFF)",
    fontFamily: "Montserrat",
    fontSize: "14px",
    fontStyle: "normal",
    fontWeight: 600,
    lineHeight: "20px",
    borderRadius: "40px",
    background: "linear-gradient(90deg, #2C4DED 0%, #9D00EC 100%)",
    padding: "10px 14px",
    boxShadow: "0 1px 2px 0 rgba(16, 24, 40, 0.05)",
  },
  planContainer: {
    position: "relative",
    display: "flex",
    flexDirection: "column",
    gap: "16px",
  },
  planStatusContainer: {
    display: "flex",
    gap: "8px",
    position: "absolute",
    top: "0",
    right: "0",
  },
  planStatus: (isSubscribed: boolean) => ({
    position: "absolute",
    top: "0",
    right: "0",
    width: "fit-content",
    fontFamily: "Montserrat",
    color: isSubscribed ? "color: var(--Brand-700, #076D0D)" : "var(--Gray-700, #344054)",
    background: isSubscribed ? "var(--Brand-50, #E7FFE4)" : "var(--Base-White, #FFF)",
    textAlign: "center",
    fontSize: "14px",
    fontStyle: "normal",
    fontWeight: 500,
    lineHeight: "20px",
    padding: "2px 8px",
    borderRadius: "6px",
    border: `1px solid ${isSubscribed ? "var(--Brand-200, #98FF90)" : "var(--Gray-300, #D0D5DD)"}`,
    boxShadow: "0 1px 2px 0 rgba(16, 24, 40, 0.05)",
  }),
  planImage: {
    width: "40px",
    height: "40px",
  },
  planTitleContainer: {
    display: "flex",
    flexDirection: "column",
    gap: "8px",
  },
  planTitle: {
    color: "var(--Dark---1000, #111)",
    fontFamily: "Montserrat",
    fontSize: "24px",
    fontStyle: "normal",
    fontWeight: 750,
    lineHeight: "normal",
  },
  planDescription: {
    color: "var(--Gray-600, #475467)",
    fontFamily: "Montserrat",
    fontSize: "16px",
    fontStyle: "normal",
    fontWeight: 400,
    lineHeight: "24px",
    minHeight: "100px",
    overflow: "hidden",
    textOverflow: "ellipsis",
    maxWidth: "240px",
    display: "-webkit-box",
    WebkitLineClamp: 5,
    WebkitBoxOrient: "vertical",
    whiteSpace: "normal",
  },
  planPriceContainer: {
    display: "flex",
    gap: "2px",
    alignItems: "flex-end",
  },
  planPrice: {
    color: "var(--Gray-900, #101828)",
    fontFamily: "Montserrat",
    fontSize: "36px",
    fontStyle: "normal",
    fontWeight: 600,
    lineHeight: "44px",
    letterSpacing: "-0.72px",
  },
  planPriceDescription: {
    fontFamily: "Montserrat",
    color: "var(--Gray-600, #475467)",
    fontSize: "14px",
    fontStyle: "normal",
    fontWeight: 500,
    lineHeight: "20px",
    pb: "6px",
  },
  creditsContainer: {
    display: "flex",
    flexDirection: "column",
    gap: "2px",
  },
  creditsTitle: {
    color: "var(--Gray-900, #101828)",
    fontFamily: "Montserrat",
    fontSize: "16px",
    fontStyle: "normal",
    fontWeight: 600,
    lineHeight: "24px",
  },
  creditsValue: {
    color: "var(--Gray-600, #475467)",
    fontFamily: "Montserrat",
    fontSize: "16px",
    fontStyle: "normal",
    fontWeight: 400,
    lineHeight: "24px",
  },
};
